import React, { FC } from 'react';
import { usePage } from '~Scenes/Handy/Context/PageProvider';
import OngoingCheque from '~Scenes/History-v2/Components/OngoingCheque';

const OngoingChequePage: FC = () => {
  const page = usePage();

  if (!page.slug) {
    return null;
  }

  return (
    <>
      <OngoingCheque chequeId={page.slug} />
    </>
  );
};

export default OngoingChequePage;
